module.exports = __webpack_public_path__ + "img/Patch10-2.2b181981.webp";